export default __webpack_public_path__ + "static/before-4-fb9c5020d81a5752e0ae3b1885dbdae9.jpeg";